import { render, staticRenderFns } from "./ClienteList.vue?vue&type=template&id=87815764&scoped=true"
import script from "./ClienteList.vue?vue&type=script&lang=js"
export * from "./ClienteList.vue?vue&type=script&lang=js"
import style0 from "./ClienteList.vue?vue&type=style&index=0&id=87815764&prod&lang=css"
import style1 from "./ClienteList.vue?vue&type=style&index=1&id=87815764&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87815764",
  null
  
)

export default component.exports